import variantReducer from './reducers'

export { default as variantSelectors } from './selectors'
export { default as variantActions } from './actions'
export { default as variantTypes } from './actionTypes'

export default variantReducer
